/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgentAssistantAvailabilityEntity
 */
export interface AgentAssistantAvailabilityEntity {
    /**
     * 
     * @type {boolean}
     * @memberof AgentAssistantAvailabilityEntity
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgentAssistantAvailabilityEntity
     */
    reason?: string;
}

/**
 * Check if a given object implements the AgentAssistantAvailabilityEntity interface.
 */
export function instanceOfAgentAssistantAvailabilityEntity(value: object): value is AgentAssistantAvailabilityEntity {
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function AgentAssistantAvailabilityEntityFromJSON(json: any): AgentAssistantAvailabilityEntity {
    return AgentAssistantAvailabilityEntityFromJSONTyped(json, false);
}

export function AgentAssistantAvailabilityEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentAssistantAvailabilityEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function AgentAssistantAvailabilityEntityToJSON(json: any): AgentAssistantAvailabilityEntity {
    return AgentAssistantAvailabilityEntityToJSONTyped(json, false);
}

export function AgentAssistantAvailabilityEntityToJSONTyped(value?: AgentAssistantAvailabilityEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'reason': value['reason'],
    };
}

